import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Layout from '../components/layout/app_layout.vue'
import HCheckPage from '../views/check/h_check_page.vue'
import StatisticPage from '../views/statistic/statistic_page.vue'
import APPCheckPage from '../views/app/h_check_page.vue'
import AICheckPage from '../views/ai/h_check_page.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: '汇付',
        component: HCheckPage
      },
      {
        path: 'statistic',
        name: '统计',
        component: StatisticPage
      },
      {
        path: 'app',
        name: 'APP反馈',
        component: APPCheckPage
      },
      {
        path: 'ai',
        name: '电话反馈',
        component: AICheckPage
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
